import { type Static, Type } from "@sinclair/typebox"

export const CardColorSchema = Type.Union([
  Type.Literal("colorless"),
  Type.Literal("red"),
  Type.Literal("yellow"),
  Type.Literal("green"),
  Type.Literal("blue"),
  Type.Literal("purple"),
])

export type CardColor = Static<typeof CardColorSchema>

export const SkillAffinitySchema = Type.Union([CardColorSchema])

export type SkillAffinity = Static<typeof SkillAffinitySchema>
